<template>
    <BasePanel :alvqa="alvqa" headline="lang_GENERIC_AZ_PANEL_CAPTION_METADATA">
        <template v-slot:panelContent>
            <v-row class="pt-4">
                <v-col cols="3">
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getLanguage"
                            :label="$t('lang_GENERIC_CAPTION_LANGUAGE')"
                            :alvqa="alvqa + '-language'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getBirthday"
                            :label="$t('lang_GENERIC_AZ_CAPTION_BIRTHDAY')"
                            :alvqa="alvqa + '-birthday'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getYearOfDeath"
                            :label="$t('lang_GENERIC_AZ_CAPTION_YEAR_OF_DEATH')"
                            :alvqa="alvqa + '-year-of-death'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getCustomerNumber"
                            :label="$t('lang_GENERIC_AZ_CAPTION_CUSTOMER_NUMBER')"
                            :alvqa="alvqa + '-customer-number'"
                        />
                    </v-row>
                </v-col>

                <v-col cols="4">
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getLabelCompany"
                            :label="$t('lang_GENERIC_AZ_CAPTION_ASSIGN_TO_LABEL_COMPANY')"
                            :alvqa="alvqa + '-label-company'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getGemaNextPrefix"
                            :label="$t('lang_AZ_PERSONS_CAPTION_GEMA_NEXT_PREFIX')"
                            :alvqa="alvqa + '-gema-next-prefix'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getGemaNextSuffix"
                            :label="$t('lang_AZ_PERSONS_CAPTION_GEMA_NEXT_PREFIX')"
                            :alvqa="alvqa + '-gema-next-suffix'"
                        />
                    </v-row>
                </v-col>

                <v-col cols="5">
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getPublishingCompany"
                            :label="$t('lang_GENERIC_AZ_CAPTION_ASSIGN_TO_PUBLISHING_COMPANY')"
                            :alvqa="alvqa + '-publishing-company'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getYesNoTranslation('GemaMember')"
                            :label="$t('lang_GENERIC_AZ_CAPTION_GEMA_MEMBER')"
                            :alvqa="alvqa + '-gema-member'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getYesNoTranslation('BgNineSplit')"
                            :label="$t('lang_GENERIC_AZ_CAPTION_BG9_FOR_GEMA_MEMBER')"
                            :alvqa="alvqa + '-bg-nine-split'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getYesNoTranslation('FreeAuthor')"
                            :label="$t('lang_GENERIC_AZ_CAPTION_FREE_AUTHOR')"
                            :alvqa="alvqa + '-free-author'"
                        />
                    </v-row>
                </v-col>
            </v-row>           
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'
import { DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "AzPersonsMetadataReadOnlyPanel",
    components: {
        BasePanel,
        BaseReadOnlyTextField
    },
    props:{
        azPersonsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'az-persons-list-read-only-panel-metadata'
        }
    },
    computed: {
        getLanguage() {
            let language = this.$store.getters.getAzPersonsMetadataDetailsLanguage
            return this.$alvPlugin.getTranslatedLanguageName(language)
        },
        getBirthday() {
            let date = this.$store.getters.getAzPersonsMetadataDetailsBirthday
            return date ? this.$d(new Date(date), 'alvDateFormat') : ''
        },
        getYearOfDeath() {
            return this.$store.getters.getAzPersonsMetadataDetailsYearOfDeath
        },
        getCustomerNumber() { return this.$store.getters.getAzPersonsMetadataDetailsCustomerNumber },
        getLabelCompany() { 
            let labelCompanyAlvId = this.$store.getters.getAzPersonsMetadataDetailsLabelCompany
            let companyName = ""
            let companyArr
            let companies = this.$store.getters.getLabelCompanies 
            if (companies !== undefined) {
                companyArr = JSON.parse(JSON.stringify(companies))
                companyArr.forEach(element => {
                    if (element['alvId'] === labelCompanyAlvId) companyName = element['name']
                });
            }
            return companyName
        },
        getPublishingCompany() { 
            let publishingCompanyAlvId = this.$store.getters.getAzPersonsMetadataDetailsPublishingCompany
            let companyName = ""
            let companyArr
            let companies = this.$store.getters.getPublishingCompanies 
            if (companies !== undefined) {
                companyArr = JSON.parse(JSON.stringify(companies))
                companyArr.forEach(element => {
                    if (element['alvId'] === publishingCompanyAlvId) companyName = element['name']
                });
            }
            return companyName
        },
        getGemaNextPrefix() { return this.$store.getters.getAzPersonsMetadataDetailsGemaNextPrefix },
        getGemaNextSuffix() { return this.$store.getters.getAzPersonsMetadataDetailsGemaNextSuffix },
    },
    methods: {
        getYesNoTranslation(context) {
            let value = this.$store.getters['getAzPersonsMetadataDetails' + context]
            if(value) {
                let result = DropdownGenericYesNo.find(element => {
                    return element.value === value
                }).text
                return this.$t(result)
            }
            return ''
        }
    },
    created() {
        this.$store.commit('setLanguages')
    }
}
</script>